var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('three-panel-condition',{attrs:{"target":_vm.target,"conditions":_vm.conditions,"prefix":_vm.prefix,"data":_vm.data,"loading":_vm.loading,"title":_vm.title,"name":_vm.name,"predicates":_vm.predicates},on:{"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }